const HIDDEN_AGENTIC_HOSTS = new Set([
  "applyt.ai",
  "home-pro-intel.tail329dc8.ts.net",
]);

/** Product visibility only. Backend permissions and existing flows are unchanged. */
export function isAgenticUiAvailable(hostname?: string | null): boolean {
  return !hostname || !HIDDEN_AGENTIC_HOSTS.has(hostname.toLowerCase());
}

export function isAgenticUiAvailableHere(): boolean {
  return isAgenticUiAvailable(typeof window === "undefined" ? undefined : window.location.hostname);
}

export function visibleWorkspaceSection(
  selected: "activity" | "flows",
  agenticUiAvailable: boolean,
): "activity" | "flows" {
  return agenticUiAvailable ? selected : "activity";
}
